import * as React from 'react';
import { Box, rem, Spacer, styled, theme } from 'design-system';

export const BaseInput = ({
  disabled,
  label,
  name,
  id,
  children,
}: React.PropsWithChildren<{
  disabled: boolean;
  label: string;
  name: string;
  id?: string;
}>) => {
  return (
    <Box>
      <Label disabled={disabled} htmlFor={id || name}>
        {label}
      </Label>
      <Spacer height={8} />
      {children}
    </Box>
  );
};

export const ErrorText = styled('span', {
  color: theme.colors.red11,
  fontSize: rem(12),
  fontWeight: theme.fontWeights.medium,
  lineHeight: rem(16),
  paddingLeft: rem(8),
});

export const Label = styled('label', {
  color: theme.colors.blue12,
  fontSize: rem(12),
  fontWeight: theme.fontWeights.semiBold,
  lineHeight: rem(16),
  paddingLeft: rem(8),

  variants: {
    disabled: {
      true: {
        color: theme.colors.gray8,
      },
      false: {},
    },
  },
});
